import { useEffect } from "react";
import { isIOS } from "react-device-detect";
import { styled } from "styled-components";

import { navbarComplementHeight } from "common/constants/navbarHeight";
import { Footer } from "domains/about/components/Footer";

export const DownloadMobileApp = () => {
  useEffect(() => {
    if (isIOS) location.replace("https://apps.apple.com/gb/app/strategic-iq/id1454211238");
  }, []);

  return <MobileAppPage />;
};

const MobileAppPage = styled(Footer)`
  box-sizing: border-box;
  height: ${navbarComplementHeight};
  justify-content: flex-start;
`;
